import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { api } from '../../lib/api'

export default function HrDashboard() {
  const navigate = useNavigate()
  const [stats, setStats] = useState({ openJobs: 0, totalJobs: 0, reportsCount: 0 })
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    api.jobs.list().then(async (res) => {
      const hrJobs = res.data.filter((j) => j.type === 'Listed' || j.type === 'Exclusive')
      const openJobs = hrJobs.filter((j) => j.status === 'Open').length

      let reportsCount = 0
      await Promise.all(
        hrJobs.map(async (job) => {
          try {
            await api.jobs.matches.getLatest(job.id)
            reportsCount++
          } catch {
            // no report
          }
        })
      )

      setStats({ openJobs, totalJobs: hrJobs.length, reportsCount })
    }).finally(() => setLoading(false))
  }, [])

  if (loading) {
    return (
      <div className="space-y-6">
        <div className="animate-pulse">
          <div className="h-7 w-48 bg-surface-lowest rounded" />
          <div className="h-4 w-72 bg-surface-lowest rounded mt-2" />
        </div>
        <div className="grid grid-cols-3 gap-4 max-w-md">
          {[1, 2, 3].map((i) => (
            <div key={i} className="h-20 bg-surface-lowest rounded-lg" />
          ))}
        </div>
      </div>
    )
  }

  return (
    <div className="space-y-10">
      <div>
        <h1 className="text-2xl font-bold text-foreground">Dashboard</h1>
        <p className="text-sm text-text-muted mt-1">Manage your hiring pipeline.</p>
      </div>

      <div className="grid grid-cols-3 gap-4 max-w-md">
        <div className="bg-surface-low border border-border-subtle rounded-lg p-4">
          <p className="text-2xl font-bold text-primary">{stats.openJobs}</p>
          <p className="text-sm text-text-muted mt-0.5">Open positions</p>
        </div>
        <div className="bg-surface-low border border-border-subtle rounded-lg p-4">
          <p className="text-2xl font-bold text-foreground">{stats.totalJobs}</p>
          <p className="text-sm text-text-muted mt-0.5">Total jobs</p>
        </div>
        <div className="bg-surface-low border border-border-subtle rounded-lg p-4">
          <p className="text-2xl font-bold text-foreground">{stats.reportsCount}</p>
          <p className="text-sm text-text-muted mt-0.5">Match reports</p>
        </div>
      </div>

      <div className="flex flex-wrap gap-3">
        <button
          onClick={() => navigate('/hr/jobs')}
          className="bg-surface-low border border-border-subtle text-foreground text-sm font-medium px-5 py-2.5 rounded-md hover:border-primary hover:text-primary transition-colors"
        >
          My jobs →
        </button>
        <button
          onClick={() => navigate('/hr/reports')}
          className="bg-surface-low border border-border-subtle text-foreground text-sm font-medium px-5 py-2.5 rounded-md hover:border-primary hover:text-primary transition-colors"
        >
          Match reports →
        </button>
      </div>
    </div>
  )
}
